(function () {
  "use strict";

  if (window.AccelerexCollectionLoadMore) return;
  window.AccelerexCollectionLoadMore = true;

  var selectors = {
    productsGrid: "[data-products-grid]",
    productLoop: "#CollectionLoop",
    loadMore: "[data-collection-load-more]",
    loadMoreLink: "[data-collection-load-more-link]",
    loadMoreText: "[data-collection-load-more-text]",
  };

  function setLoading(link, isLoading) {
    var text = link.querySelector(selectors.loadMoreText);
    var loadingText = link.getAttribute("data-loading-text") || "Loading...";

    if (!link.dataset.originalText && text) {
      link.dataset.originalText = text.textContent;
    }

    link.classList.toggle("is-loading", isLoading);
    link.setAttribute("aria-disabled", isLoading ? "true" : "false");

    if (text) {
      text.textContent = isLoading
        ? loadingText
        : link.dataset.originalText || "Load more";
    }
  }

  function showError(link) {
    var text = link.querySelector(selectors.loadMoreText);
    var errorText = link.getAttribute("data-error-text") || "Try again";
    if (!text) return;

    text.textContent = errorText;
    window.setTimeout(function () {
      text.textContent = link.dataset.originalText || "Load more";
    }, 1800);
  }

  function appendProducts(currentLoop, nextLoop) {
    var children = Array.prototype.slice.call(nextLoop.children);
    var firstNewItem = null;

    children.forEach(function (child) {
      var clone = child.cloneNode(true);
      if (!firstNewItem) firstNewItem = clone;
      currentLoop.appendChild(clone);
    });

    return firstNewItem;
  }

  function replaceLoadMore(currentControl, doc) {
    var nextControl = doc.querySelector(selectors.loadMore);

    if (nextControl) {
      currentControl.replaceWith(nextControl);
      return;
    }

    currentControl.remove();
  }

  function refreshInsertedContent(firstNewItem) {
    document.dispatchEvent(new CustomEvent("wishlist:rebound"));
    document.dispatchEvent(
      new CustomEvent("theme:collection:load-more", {
        bubbles: true,
        detail: { firstItem: firstNewItem || null },
      }),
    );

    if (window.AOS && typeof window.AOS.refreshHard === "function") {
      window.AOS.refreshHard();
    } else if (window.AOS && typeof window.AOS.refresh === "function") {
      window.AOS.refresh();
    }
  }

  function onClick(event) {
    var link =
      event.target.closest && event.target.closest(selectors.loadMoreLink);
    if (!link || link.getAttribute("aria-disabled") === "true") return;

    var productsGrid = link.closest(selectors.productsGrid);
    var currentLoop = productsGrid && productsGrid.querySelector(selectors.productLoop);
    var control = link.closest(selectors.loadMore);

    if (!productsGrid || !currentLoop || !control) return;

    event.preventDefault();

    setLoading(link, true);
    control.setAttribute("aria-busy", "true");
    productsGrid.classList.add("is-loading");

    fetch(link.href, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Load more request failed");
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var nextLoop = doc.querySelector(selectors.productLoop);
        if (!nextLoop) throw new Error("Product loop not found");

        var firstNewItem = appendProducts(currentLoop, nextLoop);
        replaceLoadMore(control, doc);
        refreshInsertedContent(firstNewItem);
      })
      .catch(function () {
        setLoading(link, false);
        showError(link);
        control.removeAttribute("aria-busy");
      })
      .finally(function () {
        productsGrid.classList.remove("is-loading");
      });
  }

  document.addEventListener("click", onClick);
})();
